import React, { useEffect, useState } from "react";
import InputForm from "../../../../../../../../components/Input/InputForm";

import { ReactSelect } from "../../../../../../../../components/Select/SelectSearch";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { IconButton, withStyles } from "@material-ui/core";
import { Button } from "../../../../../../../../components/ui/Buttons";
import Table from "../../../../../../../../components/Table/Table";
import { Delete } from "@material-ui/icons";
import { TextFieldSearch } from "../../../../../../../../components/TextField";
import { findAllProcedimentos } from "../../../../../../../../services/OrcamentoService";

const elementoSelectedDefault = {
  peLado: {
    label: "Direito",
    value: "DIREITO",
  },
  espessuraElemento: "",
  quantidadeElemento: "",
  procedimentoSelected: null,
};

const FormElementos = observer(
  ({
    classes,
    handleFieldModal,
    orcamentoStore,
    orcamento,
    tipoProcedimento,
  }) => {
    const [ladoPeOptions, setLadoPeOptions] = useState([]);
    const [countElementoOptions, setCountElementoOptions] = useState(0);
    const [reloadKey, setReloadKey] = useState(0);
    const [elementos, setElementos] = useState([]);
    const [elementoSelected, setElementoSelected] = useState(
      elementoSelectedDefault
    );

    const {
      peLado,
      espessuraElemento,
      quantidadeElemento,
      procedimentoSelected,
    } = elementoSelected;

    const {
      convenio,
      locaisPalmilhaPeDireito,
      locaisPalmilhaPeEsquerdo,
    } = orcamento || [];

    useEffect(() => {
      initialValues();
      getProcedimentos();
    }, []);

    const handleElemento = (field, value) => {
      setElementoSelected({
        ...elementoSelected,
        [field]: value,
      });

      handleFieldModal(field, value);
    };

    const getProcedimentos = () => {
      const procedimentos = orcamentoStore.orcamento.orcamentoProcedimentos.map(item => {
        const peLado = orcamentoStore.pe.find((pe) => pe.value === item.ladoPe);

        return {
          ...item,
          peLado,
          espessuraElemento: item.espessura,
          quantidadeElemento: item.quantidade,
          elemento: {
            nome: item.procedimento.nome
          }
        }
      });

      setElementos(procedimentos);
    };

    const handleAddProcedimento = (procedimento) => {
      const orcamentoProcedimentos =
        orcamentoStore.orcamento.orcamentoProcedimentos;

      const valorUnitario =
        (procedimento?.convenioProcedimentos?.find(
          (convenioProcedimento) =>
            convenioProcedimento?.convenio?.id === convenio?.value
        )?.valor || 0) * quantidadeElemento;

      const selectedProcedimentos = [
        ...orcamentoProcedimentos,
        {
          peLado,
          espessura: espessuraElemento,
          quantidade: quantidadeElemento,
          procedimento,
          valorUnitario,
        },
      ];

      handleFieldModal("orcamentoProcedimentos", selectedProcedimentos);
    };
     const handleDeleteProcedimento = (elementos) => {

      const selectedProcedimentos = elementos.map((elemento) => {
        const valorConvenioProcedimento =
        elemento?.elemento?.convenioProcedimentos?.find(
          (convenioProcedimento) =>
            convenioProcedimento?.convenio?.id === convenio?.value
        )?.valor || 0
        
        const valorUnitario  = valorConvenioProcedimento * elemento.quantidadeElemento
        return {
          peLado: elemento.peLado.value,
          espessura: elemento.espessuraElemento,
          quantidade: elemento.quantidadeElemento,
          procedimento: elemento.elemento,
          valorUnitario,
        };
      } )

      handleFieldModal("orcamentoProcedimentos", selectedProcedimentos);
    };
    const handleLoadMoreProcedimentos = async ({ search, data }) => {
      let pageableDTO = {
        sortDir: "ASC",
        sortField: "nome",
        pageNumber: data.page,
        pageSize: 20,
      };

      const response = await findAllProcedimentos({
        nome: search,
        ativo: true,
        pageableDTO,
        tiposProcedimentos: [tipoProcedimento.value],
      });

      const { content, last } = response;

      if (content) {
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: data.page + 1,
          },
        };
      }
    };
    const columns = [
      {
        Header: "Pé",
        align: "start",
        getValue: (elemento) => {
          return elemento.peLado.label;
        },
      },
      {
        Header: "Nome",
        align: "start",
        getValue: (elemento) => {
          return elemento.elemento.nome;
        },
      },
      {
        Header: "Espessura",
        align: "start",
        getValue: (elemento) => {
          return elemento.espessuraElemento;
        },
      },
      {
        Header: "Quantidade",
        align: "start",
        getValue: (elemento) => {
          return elemento.quantidadeElemento;
        },
      },
      {
        Header: "",
        align: "start",
        getValue: (elemento) => {
          const handleDelete = () => {
            const elementoOptionsFiltered = elementos.filter(
              (item) => item.id !== elemento.id
            );
          setElementos(elementoOptionsFiltered);
          handleDeleteProcedimento(elementoOptionsFiltered)
          
          };
          return (
            <IconButton
              id={`pac-mor-btn-exc-${elemento.id}`}
              style={{background:"#ffff"}}
              className={classes.deleteButton}
              onClick={handleDelete}
            >
              <Delete color="#505050" />
            </IconButton>
          );
        },
      },
    ];

    const selectElementoOptions = (lado) => {
      if (lado.value === "DIREITO") {
        setLadoPeOptions([...locaisPalmilhaPeDireito]);
      } else {
        setLadoPeOptions([...locaisPalmilhaPeEsquerdo]);
      }
      handleFieldModal("elemento", null);
    };
    const initialValues = () => {
      if (ladoPeOptions.length > 0) return;
      selectElementoOptions(peLado);
    };

    const loadProcedimentos = async (search, loadedOptions, { page }) => {
      return handleLoadMoreProcedimentos({
        search,
        data: { page },
      });
    };

    const handleAdicionarElemento = () => {
      const elementoOptions = {
        id: countElementoOptions,
        peLado,
        elemento: { ...procedimentoSelected },
        espessuraElemento,
        quantidadeElemento,
      };
      setCountElementoOptions((count) => count + 1);
      setElementos((elemento) => [...elemento, elementoOptions]);
      handleAddProcedimento(procedimentoSelected);
      setElementoSelected(elementoSelectedDefault);
    };
    return (
      <div>
        <div className={classes.containerElemento}>
          <div className={classes.containerElements}>
            <label className={classes.title}>Pé*</label>
            <ReactSelect
              id="pac-mor-sel-pel"
              className={classes.select}
              options={orcamentoStore.pe}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(e) => handleElemento("peLado", e)}
              value={peLado}
            />
          </div>
          <div className={classes.containerElements}>
            <label>Elemento*</label>
            <TextFieldSearch
              id="pac-mor-txt-ele"
              key={reloadKey}
              classNotched={classes.notchedOutline}
              classInput={classes.inputTextField}
              classIcons={classes.classIcons}
              placeholder={"Selecione o item"}
              disabled={true}
              onChange={(e) => handleElemento("procedimentoSelected", e)}
              menuPlacement={"auto"}
              value={procedimentoSelected}
              isClearable
              getOptionLabel={(option) =>
                option.nome || option.procedimento?.nome
              }
              getOptionValue={(option) => {
                return option.id || option.procedimento?.id;
              }}
              withPaginate
              loadOptions={tipoProcedimento.value && loadProcedimentos}
              debounceTimeout={300}
              additional={{
                page: 0,
              }}
            />
          </div>
          <div className={classes.containerElements}>
            <label className={classes.title}>Espessura mm*</label>

            <InputForm
              id="pac-mor-inp-esp"
              placeholder={"Selecione a espessura"}
              className={classes.inputContainer}
              onChange={(e) =>
                handleElemento("espessuraElemento", e.target.value)
              }
              value={espessuraElemento}
            />
          </div>
          <div className={classes.containerElements}>
            <label>Quantidade*</label>
            <InputForm
              id="pac-mor-inp-qtd"
              placeholder={"Selecione a quantidade"}
              className={classes.inputContainer}
              type="number"
              onChange={(e) =>
                handleElemento("quantidadeElemento", e.target.value)
              }
              value={quantidadeElemento}
            />
          </div>

          <Button
            id="pac-mor-btn-add"
            className={classes.button}
            bgColor="#26ACAA"
            onClick={handleAdicionarElemento}
            disabled={
              !peLado ||
              !procedimentoSelected ||
              !quantidadeElemento ||
              !espessuraElemento
            }
          >
            Adicionar
          </Button>
        </div>
        <Table columns={columns} dados={[...elementos]} />
      </div>
    );
  }
);
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    border: "1px solid rgba(0, 0, 0, 0.10)",
    borderRadius: "10px",
    height: "calc(100% - 100px)",
    justifyContent: "space-between",
    color: "#868686",

    "& thead tr": {
      textAlign: "left",
      height: "32px",
    },
  },
  tableRoot: {
    height: "100%",
  },
  contentProcedimentos: {
    margin: "16px 16px 0",
  },
  notchedOutline: {
    border: "0",
  },
  contentTotal: {
    height: "40px",
    paddingRight: "8px",
    textAlign: "end",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
    gap: "4px",
  },
  total: {
    fontWeight: 600,
    fontSize: 16,
  },
  totalValue: {
    fontWeight: 600,
    fontSize: 18,
  },
  table: {
    height: "100%",
    overflow: "auto",
  },
  tableMenor: {
    maxHeight: "130px",
  },
  containerTotal: {
    display: "flex",
    justifyContent: "end",
    paddingLeft: "10px",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  },
  select: {
    width: "100%",
  },
  reactSelects: {
    gap: "10px",
    paddingTop: "10px",
    display: "flex",
    flexDirection: "column",
  },
  contentSelect: {
    gap: "15px",
  },
  inputContainer: {
    width: "100%",
    background: "#F2F2F2",
    color: "#505050",
    borderRadius: "8px",
    height: "30px",
    "& > div": {
      height: "30px",
      "& > input": {
        height: "30px",
        border: "none",
      },
    },
  },
  containerElements: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px",
  },
  containerElemento: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
    marginBottom: "10px",
    gap: "5px",
    alignItems: "center",
  },
  button: {
    height: "40px",
  },
  deleteButton: {
    background: "#F2F2F2",
    border: "none",
    color: "#505050 !important",
  },
};
const FormElementosWithStyles = withStyles(styles)(FormElementos);
export default inject("orcamentoStore")(FormElementosWithStyles);
